module.exports = __webpack_public_path__ + "img/saurav.19c12390.png";